<div
    class="st-planning-view-item-main"
    [class.st-planning-view-item-selected]="isSelected"
    (click)="selectNavigationItem()">
    <div class="st-planning-view-item-drag-handle"></div>
    <div class="st-planning-view-item-container">
        <div class="st-planning-view-item-container-left">
            <st-avatar
                big
                [userId]="record.owner" />

            <div class="st-planning-view-item-container-info">
                <div class="st-planning-view-item-container-info--name">{{ label }}</div>
                <div class="st-planning-view-item-container-info--date">{{ createdDate }}</div>
            </div>
        </div>
        <div class="st-planning-view-item-container-right">
            <div class="st-planning-view-item-container-right-buttons">
                <button
                    class="st-planning-view-item-container-right-buttons--delete btn"
                    [title]="delete"
                    [disabled]="!canDelete"
                    (click)="deleteNavigationItem($event)">
                    <mat-icon> delete_outline </mat-icon>
                </button>
                <button
                    class="st-planning-view-item-container-right-buttons--bookmark btn"
                    [title]="bookmark"
                    (click)="bookmarkNavigationItem($event)">
                    <mat-icon
                        *ngIf="isSelected"
                        class="st-planning-view-item-container-right-buttons--bookmark-selected">
                        bookmark
                    </mat-icon>
                    <mat-icon
                        *ngIf="!isSelected"
                        class="material-symbols-outlined">
                        bookmark_add
                    </mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
